import { resolveStructuredReportConfig } from './utils/generatorConfig.js';

const injectedGeneratorConfigJson = '{"contract_version": 1, "app": {"name": "Dream Lens Dogfood", "slug": "dream-lens-dogfood", "description": "Generate a structured interpretation report from a remembered dream.", "genre": "structured-report", "locale": "en-US"}, "input": {"submit_label": "Interpret dream", "fields": [{"key": "dream", "label": "Dream description", "type": "long_text", "required": true, "placeholder": "Describe the dream in detail.", "default": "I walked through a quiet city at night and found a lit doorway with my name on it."}, {"key": "mood", "label": "Mood", "type": "select", "required": false, "options": [{"label": "Calm", "value": "calm"}, {"label": "Anxious", "value": "anxious"}, {"label": "Curious", "value": "curious"}], "default": "curious"}]}, "result": {"title": "Dream report", "sections": [{"key": "report", "label": "Report", "source": "answer"}], "fallback_source": "answer"}, "access": {"guest_quota": {"enabled": true, "limit": 3, "period": "day"}, "auth": {"enabled": false, "provider": "logto"}, "payment": {"enabled": false, "provider": "stripe", "cta": "Unlock full report"}}, "share": {"title": "Dream Lens Dogfood", "description": "Generate a structured AI dream interpretation.", "cta": "Try your own reading", "copy_template": "I generated a dream interpretation with {{APP_NAME}}."}, "theme": {"accent_color": "#4f46e5", "background": "#f8fafc", "surface": "#ffffff", "text": "#111827", "radius": "8px"}, "deployment": {"target": "cloudflare-pages", "build_command": "npm run build", "output_dir": "dist", "wrangler_project_name": "dream-lens-dogfood-app"}}';
const injectedI18nMessagesJson = '{"en": {"loading": "Loading...", "guestMode": "Guest Mode - Limited Usage", "usageThisMonth": "Usage This Month", "monthlyUsage": "Monthly Usage", "requests": "requests", "messages": "messages", "remainingThisMonth": "Only {count} requests remaining this month", "messagesRemainingThisMonth": "Only {count} messages remaining this month", "readyTitle": "Ready to generate", "readyDescription": "Enter a prompt above to get started with AI-powered completions.", "poweredBy": "Powered by", "guestFooter": "Sign in for unlimited access and premium features", "quotaExceeded": "You have reached your quota limit. Please upgrade your plan to continue.", "guestQuotaExceeded": "You have reached the daily limit for guest users. Please sign in to continue.", "paymentRequired": "Free usage is exhausted. Sign in or upgrade to continue.", "generationFailed": "Failed to generate completion. Please try again.", "chatFailed": "Failed to send message. Please try again.", "copyFailed": "Failed to copy to clipboard", "generating": "Generating...", "clear": "Clear", "tryExamples": "Try these examples:", "promptTooLong": "Prompt is too long. Please keep it under {maxLength} characters.", "messageTooLong": "Message is too long. Please keep it under {maxLength} characters.", "generatedResponse": "Generated Response", "noResponse": "No response generated.", "copied": "Copied!", "copy": "Copy", "share": "Share", "yourPrompt": "Your prompt:", "input": "Input:", "output": "Output:", "tokens": "tokens", "time": "Time:", "signInRequired": "Sign In Required", "signInRequiredBody": "Please sign in to access this feature.", "guestLimitBody": "You\'ve reached the daily limit for guest users. Please sign in to continue using the service.", "signInToContinue": "Sign In to Continue", "welcome": "Welcome!", "guestChoiceBody": "Sign in for unlimited access, or continue as a guest with limited usage.", "guestModeLabel": "Guest Mode:", "guestRequestsRemaining": "{count} requests remaining today", "signInFullAccess": "Sign In for Full Access", "continueAsGuest": "Continue as Guest ({count} left)", "upgradeBenefits": "Upgrade Benefits", "premiumFeatures": "Premium Features", "unlimitedRequests": "Unlimited requests", "prioritySupport": "Priority support", "advancedFeatures": "Advanced features", "usageAnalytics": "Usage analytics", "startConversation": "Start a conversation", "guestModePrefix": "Guest Mode - ", "exportChat": "Export chat", "clearChat": "Clear chat", "clearChatConfirm": "Are you sure you want to clear the chat? This action cannot be undone.", "noMessagesExport": "No messages to export.", "suggestions": "Suggestions:", "typeMessage": "Type your message here...", "typeMessageGuest": "Type a message (guest mode)...", "typeMessageDefault": "Type a message...", "assistantFallback": "Sorry, I couldn\'t generate a response."}, "zh-CN": {"loading": "加载中...", "guestMode": "访客模式 - 使用次数有限", "usageThisMonth": "本月用量", "monthlyUsage": "本月用量", "requests": "次请求", "messages": "条消息", "remainingThisMonth": "本月仅剩 {count} 次请求", "messagesRemainingThisMonth": "本月仅剩 {count} 条消息", "readyTitle": "可以开始生成", "readyDescription": "在上方输入内容，开始使用 AI 生成结果。", "poweredBy": "由", "guestFooter": "登录后可获得不限次数访问和高级功能", "quotaExceeded": "你已达到用量限制，请升级方案后继续。", "guestQuotaExceeded": "访客今日使用次数已达上限，请登录后继续。", "paymentRequired": "免费额度已用完，请登录或充值后继续。", "generationFailed": "生成失败，请重试。", "chatFailed": "消息发送失败，请重试。", "copyFailed": "复制到剪贴板失败", "generating": "生成中...", "clear": "清除", "tryExamples": "试试这些示例：", "promptTooLong": "输入过长，请控制在 {maxLength} 个字符以内。", "messageTooLong": "消息过长，请控制在 {maxLength} 个字符以内。", "generatedResponse": "生成结果", "noResponse": "没有生成结果。", "copied": "已复制", "copy": "复制", "share": "分享", "yourPrompt": "你的输入：", "input": "输入：", "output": "输出：", "tokens": "token", "time": "耗时：", "signInRequired": "需要登录", "signInRequiredBody": "请登录后使用此功能。", "guestLimitBody": "访客今日使用次数已达上限，请登录后继续使用。", "signInToContinue": "登录后继续", "welcome": "欢迎！", "guestChoiceBody": "登录可获得不限次数访问，也可以先以访客身份继续。", "guestModeLabel": "访客模式：", "guestRequestsRemaining": "今日剩余 {count} 次请求", "signInFullAccess": "登录获取完整访问", "continueAsGuest": "以访客身份继续（剩余 {count} 次）", "upgradeBenefits": "升级权益", "premiumFeatures": "高级功能", "unlimitedRequests": "不限次数请求", "prioritySupport": "优先支持", "advancedFeatures": "高级功能", "usageAnalytics": "用量分析", "startConversation": "开始对话", "guestModePrefix": "访客模式 - ", "exportChat": "导出对话", "clearChat": "清除对话", "clearChatConfirm": "确定要清除对话吗？此操作无法撤销。", "noMessagesExport": "没有可导出的消息。", "suggestions": "建议：", "typeMessage": "在这里输入消息...", "typeMessageGuest": "输入消息（访客模式）...", "typeMessageDefault": "输入消息...", "assistantFallback": "抱歉，我暂时无法生成回复。"}}';
const env = import.meta.env || {};
const defaultGeneratorConfig = {
  input: {
    submit_label: 'Generate report',
    fields: [
      {
        key: 'query',
        label: 'Report brief',
        type: 'long_text',
        required: true,
        placeholder: 'Describe the situation you want analyzed...',
        max_length: 2000,
      },
    ],
    examples: [
      'Analyze this dream: I was walking through a quiet city at night',
      'Create a personal reading for someone starting a new project',
      'Assess whether this career decision fits my current priorities',
      'Interpret this recurring situation and suggest next steps',
    ],
  },
  result: {
    title: 'Personalized report',
    sections: [
      { key: 'report', label: 'Report', source: 'answer' },
    ],
    fallback_source: 'answer',
  },
};

function parseGeneratorConfig() {
  if (!injectedGeneratorConfigJson || injectedGeneratorConfigJson.startsWith('{{')) {
    return defaultGeneratorConfig;
  }
  try {
    return {
      ...defaultGeneratorConfig,
      ...JSON.parse(injectedGeneratorConfigJson),
    };
  } catch {
    return defaultGeneratorConfig;
  }
}

function parseJsonConfig(value, fallback) {
  if (!value || value.startsWith('{{')) {
    return fallback;
  }
  try {
    return JSON.parse(value);
  } catch {
    return fallback;
  }
}

function normalizeLocale(value) {
  const normalized = String(value || '').replace('_', '-').toLowerCase();
  if (['zh', 'zh-cn', 'zh-hans', 'cn'].includes(normalized)) return 'zh-CN';
  if (['en', 'en-us', 'en-gb'].includes(normalized)) return 'en';
  return 'en';
}

const parsedGeneratorConfig = parseGeneratorConfig();
const appLocale = normalizeLocale(env.VITE_APP_LOCALE || parsedGeneratorConfig.locale || 'en');

// ============================================
// 应用配置 - Creator 需要修改这部分
// ============================================

export const APP_CONFIG = {
  // 必填：你的 PromptaaS API 基础 URL
  API_BASE_URL: env.VITE_API_BASE_URL || 'https://promptaas-runtime-gateway.whilgeek.workers.dev/api',

  // 必填：你的应用 slug (在 PromptaaS 中创建应用时生成的)
  APP_SLUG: env.VITE_APP_SLUG || 'dream-lens-dogfood',

  // 应用运行时类型
  APP_TYPE: env.VITE_APP_TYPE || 'prompt',
  INTERACTION_MODE: env.VITE_INTERACTION_MODE || 'completion',
  LOCALE: appLocale,
  I18N_MESSAGES: parseJsonConfig(injectedI18nMessagesJson, {}),
  RUNTIME_ENDPOINTS: {
    completion: `/app/${env.VITE_APP_SLUG || 'dream-lens-dogfood'}/completion-messages`,
    chat: `/app/${env.VITE_APP_SLUG || 'dream-lens-dogfood'}/chat-messages`,
    workflow: `/app/${env.VITE_APP_SLUG || 'dream-lens-dogfood'}/workflows/run`,
    parameters: `/app/${env.VITE_APP_SLUG || 'dream-lens-dogfood'}/parameters`,
  },
  CREDIT_ENDPOINTS: {
    packages: `/app/${env.VITE_APP_SLUG || 'dream-lens-dogfood'}/credits/packages/`,
    balance: `/app/${env.VITE_APP_SLUG || 'dream-lens-dogfood'}/credits/balance/`,
    transactions: `/app/${env.VITE_APP_SLUG || 'dream-lens-dogfood'}/credits/transactions/`,
    checkout: `/app/${env.VITE_APP_SLUG || 'dream-lens-dogfood'}/credits/checkout/`,
    verify: `/app/${env.VITE_APP_SLUG || 'dream-lens-dogfood'}/credits/verify/`,
  },

  // API认证配置 (自动配置，无需修改)
  API_KEY: env.VITE_API_KEY || 'pk_app_x14wjFx4sihRILo__cxidnFfH7sC7LbH', // Public runtime token
  BEARER_TOKEN: 'Bearer pk_app_x14wjFx4sihRILo__cxidnFfH7sC7LbH',

  // 可选：应用标题 (显示在页面头部)
  APP_TITLE: env.VITE_APP_NAME || 'AI Report',

  // 可选：应用描述
  APP_DESCRIPTION: env.VITE_APP_DESCRIPTION || 'Create a focused AI report from your input',

  // 可选：占位符文本
  PLACEHOLDER_TEXT: 'Describe the situation you want analyzed...',

  // 可选：提交按钮文本
  SUBMIT_BUTTON_TEXT: 'Generate report',

  // 可选：报告标题
  REPORT_LABEL: 'Personalized report',

  // 模板生成器配置：下载时由 PromptaaS 注入
  GENERATOR_CONFIG: parsedGeneratorConfig,

  // 可选：示例提示词
  EXAMPLE_PROMPTS: [
    'Analyze this dream: I was walking through a quiet city at night',
    'Create a personal reading for someone starting a new project',
    'Assess whether this career decision fits my current priorities',
    'Interpret this recurring situation and suggest next steps'
  ],

  // 可选：是否显示示例提示词
  SHOW_EXAMPLES: true,

  // 可选：UI 定制
  UI_CONFIG: {
    // 主题色
    PRIMARY_COLOR: 'blue',
    // 是否显示清除按钮
    SHOW_CLEAR_BUTTON: true,
    // 最大输入长度
    MAX_INPUT_LENGTH: 2000,
    // 是否显示字符计数
    SHOW_CHARACTER_COUNT: true
  }
};

export const REPORT_CONFIG = resolveStructuredReportConfig(APP_CONFIG.GENERATOR_CONFIG, {
  appName: APP_CONFIG.APP_TITLE,
  appDescription: APP_CONFIG.APP_DESCRIPTION,
});

// ============================================
// 认证配置 - Logto Integration
// ============================================

export const AUTH_CONFIG = {
  // 是否启用认证
  ENABLED: env.VITE_ENABLE_AUTH === 'true',

  // Logto 配置
  LOGTO: {
    ENDPOINT: env.VITE_LOGTO_ENDPOINT || '',
    APP_ID: env.VITE_LOGTO_APP_ID || '',
    SCOPES: ['openid', 'profile', 'email'],
    RESOURCES: []
  },

  // 认证相关 UI 配置
  UI: {
    SHOW_GUEST_MODE: true, // 是否允许访客模式
    GUEST_QUOTA: 3, // 访客模式下的使用次数限制
    LOGIN_REDIRECT: '/auth/callback',
    LOGOUT_REDIRECT: '/'
  }
};

// ============================================
// 付费配置 - Stripe Integration
// ============================================

export const BILLING_CONFIG = {
  // 是否启用付费功能
  ENABLED: env.VITE_ENABLE_BILLING === 'true',

  // Stripe 配置
  STRIPE: {
    PUBLISHABLE_KEY: env.VITE_STRIPE_PUBLISHABLE_KEY || '',
    CURRENCY: 'usd'
  },

  // 定价配置
  PRICING: {
    // 免费用户限制
    FREE_TIER: {
      REQUESTS_PER_DAY: 10,
      REQUESTS_PER_MONTH: 100
    },

    // 付费计划
    PLANS: [
      {
        id: 'basic',
        name: 'Basic Plan',
        price: 9.99,
        interval: 'month',
        features: [
          '1000 requests per month',
          'Email support',
          'Basic analytics'
        ]
      },
      {
        id: 'pro',
        name: 'Pro Plan',
        price: 29.99,
        interval: 'month',
        features: [
          '10000 requests per month',
          'Priority support',
          'Advanced analytics',
          'Custom integrations'
        ]
      }
    ]
  },

  // 付费相关 UI 配置
  UI: {
    SHOW_USAGE_METER: true,
    SHOW_UPGRADE_PROMPT: true,
    ALLOW_TRIAL: true,
    TRIAL_DAYS: 7
  }
};

// ============================================
// 高级配置 - 通常不需要修改
// ============================================

export const ADVANCED_CONFIG = {
  // API 请求超时时间 (毫秒)
  REQUEST_TIMEOUT: 30000,

  // 重试次数
  MAX_RETRIES: 3,

  // 错误消息显示时间 (毫秒)
  ERROR_DISPLAY_DURATION: 5000,

  // 动画配置
  ANIMATION: {
    FADE_IN_DURATION: 300,
    LOADING_DELAY: 200
  },

  // 本地存储配置
  STORAGE: {
    AUTH_TOKEN_KEY: 'auth_token',
    USER_PREFERENCES_KEY: 'user_preferences',
    USAGE_STATS_KEY: 'usage_stats'
  }
};
